import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'toggle-checkbox',
    templateUrl: './toggle-checkbox.component.html',
    styleUrls: ['./toggle-checkbox.component.scss']
})
export class ToggleCheckboxComponent implements OnInit {
	@Input()  required: boolean = false;
	@Input()  disabled: boolean = false;
    @Input()  text: string = "";
    @Input()  colorOn: string = "success";
    @Input()  colorOff: string = "danger";
	@Input()  iValue: boolean;
    @Output() iValueChange: EventEmitter<boolean> = new EventEmitter();
    @Output() change: EventEmitter<boolean> = new EventEmitter();

    selected: boolean;
    
	ngOnChanges(changes: SimpleChanges)
	{
		if(changes.iValue) {
			this.selected = changes.iValue.currentValue;
		}
	}

    constructor()
	{
	}

    ngOnInit()
	{
	}

	toggle()
	{
		this.selected = !this.selected;
        this.iValueChange.emit(this.selected);
        this.change.emit(this.selected);
    }

    getButtonClass()
    {
        return 'btn-' + (this.selected ? this.colorOn : this.colorOff);
    }

}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/components/toggle-checkbox/toggle-checkbox.component.ts